export class Address {
  streetName: string
  houseNumber: string
  zipCode: string
  city: string
  country: string
  countryId: number
}
